import { Link } from "react-router";

import readme from "../../../sdk/README.md?raw";

import { Markdown } from "@/components/markdown";
import { outline } from "@/lib/markdown";

/**
 * The SDK's README, as a page.
 *
 * Nothing here is written twice. The README is the file that ships inside the package
 * students install (`vis_nav_sdk`'s long description), imported at build time from the
 * `sdk/` directory of the same repository; a change to the SDK's documentation is a change
 * to this page, and this page cannot describe an API the package does not have.
 *
 * Setting up for the course -- the starter kit, teams, attempts, scoring -- is the
 * getting-started page, which is the site's own text and links here for the API.
 */

// The README opens with "# vis-nav-sdk"; the page has its own title, so the body starts
// at the first paragraph.
const BODY = readme.replace(/^# .*\n/, "");
const SECTIONS = outline(BODY);

export function SdkReferenceRoute() {
  return (
    <div className="space-y-6">
      <div className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight">SDK reference</h1>
        <p className="text-muted-foreground text-sm">
          The <code className="font-mono">vis-nav-sdk</code> README -- the same text that ships
          with the package. New to the course? Start with{" "}
          <Link to="/" className="text-primary underline-offset-4 hover:underline">
            the tutorial
          </Link>
          .
        </p>
      </div>

      <div className="grid gap-8 lg:grid-cols-[minmax(0,1fr)_14rem]">
        <article className="min-w-0">
          <Markdown source={BODY} />
        </article>

        <nav aria-label="On this page" className="hidden lg:block">
          <div className="sticky top-20 space-y-1">
            <p className="text-muted-foreground mb-2 text-xs font-medium tracking-wide uppercase">
              On this page
            </p>
            {SECTIONS.map((section) => (
              <a
                key={section.id}
                href={`#${section.id}`}
                className="text-muted-foreground hover:text-foreground block truncate py-0.5 text-sm transition-colors"
              >
                {section.title}
              </a>
            ))}
          </div>
        </nav>
      </div>
    </div>
  );
}
